/* Package JSON Import will be here */
import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
/* Package JSON Import will be here */

/* Project Import will be here */
import EmployeeComponent from './employee.Component';
import { MessageBox } from '../sharedComponent/messageBox';
import { Constants } from '../../config/appConstants';
import * as utility from '../../services/utility';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import * as actions from '../../actions/tab.Action';
import * as timeCardActions from '../../actions/timeCardDatas.Action';
import * as onDefaultGroupByAction from '../../actions/timecardDefaultGroupBy.Action';
import * as onHistorySaveAction from '../../actions/history.Action';
import * as projectAndTaskAction from "../../actions/projectAndTask.Action";
import * as lastSavedPunchesAction from "../../actions/lastSavedPunches.Action";
import { CheckEnterHours } from '../timeCard/Attestation/AttestationUtils';
/* Const,Let & Var will be here */

class Employee extends Component {
    constructor(props) {
        super(props);

        const returnUndefinedForEmptyString = (value) => {
            return (!value || value === "") ? undefined : value
        }

        const locationState = this?.props?.location?.state ?? undefined;
        const timeCardState = this?.props?.timeCard ?? undefined;
        const isAddTimeCard = locationState?.isAddTimeCard ?? false;
        const isFromTimeCard = locationState?.isFromTimeCard ?? false;
        const isBothNotExist = !isAddTimeCard && !isFromTimeCard;

        const selectedProject = timeCardState?.project ?? "";
        const selectedTaskCode = timeCardState?.taskCode ?? "";
        const selectedShift = isBothNotExist ? Constants.DAY : (timeCardState?.shift ?? "");
        const selectedPayCode = isBothNotExist ? Constants.ST : (timeCardState?.payCode ?? "");
        const selectedHours = returnUndefinedForEmptyString(timeCardState?.hours) ?? "8";
        const savedStartTime = timeCardState?.startTime ?? "";
        const savedEndTime = timeCardState?.endTime ?? "";
        const savedLunchStartTime = timeCardState?.lunchStartTime ?? "";
        const savedLunchEndTime = timeCardState?.lunchEndTime ?? "";

        const alreadySelectedTask = returnUndefinedForEmptyString(locationState?.selectedTask);
        const newlySelectedTask = (
            selectedProject?.projectNumber !== "" &&
            selectedTaskCode?.projectNumber !== "" &&
            selectedProject.projectNumber === selectedTaskCode.projectNumber
        ) ? selectedTaskCode : "";
        const selectedTask = alreadySelectedTask ?? newlySelectedTask;
        const timeCardDatas = locationState?.timeCardDatas ?? "";
        const selectedGroupBy = locationState?.groupBy ?? "";
        const selectedDate = this?.props?.date?.selectedDate ?? "";
        const selectedRowData = locationState?.selectedRowData ?? "";

        this.state = {
            isSelectShiftModelVisible: false,
            isHoursTypeModelVisible: false,
            isHoursModelVisible: false,
            isConfirmationModelVisible: false,
            Overrides: [
                { key: 0, value: 'job', title: 'Job' },
                { key: 1, value: 'union', title: 'Union' }
            ],
            workDone: [
                { key: 1, value: 'yes', title: 'Yes' },
                { key: 2, value: 'no', title: 'No' }
            ],
            allEmployeeList: [],
            allEmployeeListWithGrp: [],
            allProjectList: [],
            allTaskList: [],
            selectedProject: selectedProject,
            selectedTask: selectedTask,
            savedProject: selectedProject,
            savedTask: selectedTaskCode,
            selectedEmployeeList: [],
            selectedTab: isFromTimeCard ? 'starttimeandtunchtime' : "",
            timeCardDataFromTCPage: isFromTimeCard ? timeCardDatas : "",
            previousTab: "",
            employeeSearchText: "",
            projectSearchText: "",
            taskSearchText: "",
            savedShift: isAddTimeCard ? Constants.DAY : selectedShift,
            onSelectedShift: isAddTimeCard ? Constants.DAY : selectedShift,
            savedHoursType: isAddTimeCard ? Constants.ST : selectedPayCode,
            onSelectedHoursType: isAddTimeCard ? Constants.ST : selectedPayCode,
            onSelectedHours: selectedHours,
            savedHoursValue: selectedHours,
            empGrpList: [],
            activeEmpGroupIds: [],
            activeIndexForEmpGroup: [],
            taskGrpList: [],
            activeTaskGroupIds: [],
            selectedPickerName: "",
            activeIndexForTaskGroup: [],
            isShowLoader: false,
            assignedProjectNumberList: [],
            deviceName: '',
            selectedDate: selectedDate,
            groupBy: isFromTimeCard ? selectedGroupBy : "",
            tasksNotInSelectedProject: [],
            availabelTaskList: [],
            selectedGroupTask: '',

            startHour: '',
            startMinute: '',
            endHour: '',
            endMinute: '',
            lunchStartHour: '',
            lunchStartMinute: '',
            lunchEndHour: '',
            lunchEndMinute: '',
            initialPunches: {},
            startHourInputRef: createRef(),
            startMinuteInputRef: createRef(),
            endHourInputRef: createRef(),
            endMinuteInputRef: createRef(),
            lunchStartHourInputRef: createRef(),
            lunchStartMinuteInputRef: createRef(),
            lunchEndHourInputRef: createRef(),
            lunchEndMinuteInputRef: createRef(),
            savedStartTime: savedStartTime,
            savedEndTime: savedEndTime,
            savedLunchStartTime: savedLunchStartTime,
            savedLunchEndTime: savedLunchEndTime,
            isShowAlreadyAttestedModal: false,
            selectedRowData: selectedRowData,
            isFromTimeCard: isFromTimeCard,
            disableSaveButton: false
        };
    };

    componentDidMount() {
        let { selectedEmployeeList, savedProject, savedTask, savedHoursValue, savedShift, savedHoursType, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, isFromTimeCard } = this.state;

        this.props.onHistorySave(window.location.pathname);

        if (this.props.previousHistoryReducer.previousHistory === "/CreateEmpGroup" || this.props.previousHistoryReducer.previousHistory === "/CreateTaskGroup") {
            selectedEmployeeList = this?.props?.history?.location?.state?.selectedEmployeeList ?? [];
        }

        if (!isFromTimeCard) {
            this.props.timeCardDatas(savedProject, savedTask, savedHoursValue, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, savedShift, savedHoursType);
            this.getEmpGroup();
            this.getProjectList(true);
            if (this.props.tab.selectedTabName !== "") {
                this.setState({
                    selectedTab: this.props.tab.selectedTabName
                }, () => {
                    this.getTaskGroup(true);
                    this.props.onTabSelect("");
                })
            }
        }

        const device = this.props.user.deviceEmpID.split('_');
        device.shift();
        device.pop();
        const deviceName = device.join('_');

        let [startHour, startMinute] = utility.timeSpliting(savedStartTime);
        let [endHour, endMinute] = utility.timeSpliting(savedEndTime);
        let [lunchStartHour, lunchStartMinute] = utility.timeSpliting(savedLunchStartTime);
        let [lunchEndHour, lunchEndMinute] = utility.timeSpliting(savedLunchEndTime);

        const { hasData, punchesData, onSelectedHours } = this.getTimeCardPunches();
        if (hasData) {
            ({
                startHour, startMinute,
                endHour, endMinute,
                lunchStartHour, lunchStartMinute,
                lunchEndHour, lunchEndMinute,
                savedStartTime, savedEndTime,
                savedLunchStartTime, savedLunchEndTime
            } = punchesData);
        }

        const initialPunches = { savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime };
        this.setState({ deviceName, selectedEmployeeList, startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute, initialPunches, onSelectedHours, ...initialPunches });
    }

    getTimeCardPunches() {
        const { timeCardDataFromTCPage, groupBy, isFromTimeCard, selectedRowData, onSelectedHours } = this.state
        const timeCardData = timeCardDataFromTCPage;
        const selectedTimeCard = timeCardData ? (groupBy === Constants.PROJECT ? timeCardData : (timeCardData?.timecardData[0] ?? {})) : "";

        if (!selectedTimeCard || !isFromTimeCard || Object.keys(selectedTimeCard).length === 0) {
            return {
                hasData: false,
                onSelectedHours,
                punchesData: [],
            };
        }

        let stHours = 0;
        let otHours = 0;
        let dtHours = 0;
        let selectedHours = onSelectedHours;
        const timeCardList = groupBy === Constants.PROJECT ? selectedRowData : (timeCardData?.timecardData ?? []);

        if (timeCardList?.length > 0) {
            for (const data of timeCardList) {
                stHours += data.stHours;
                otHours += data.otHours;
                dtHours += data.dtHours;
            }
            const totalHours = parseFloat(stHours) + parseFloat(otHours) + parseFloat(dtHours);
            selectedHours = totalHours;
        }

        const checkStartAndEndTime = (selectedTime) => {
            return selectedTime === Constants.NOT_APPLICABLE && selectedHours > 0;
        }

        const checkLunchStartAndEndTime = (selectedTime) => {
            return selectedTime === Constants.NOT_APPLICABLE && CheckEnterHours(selectedHours);
        }

        const {
            startTime,
            endTime,
            lunchStartTime,
            lunchEndTime
        } = selectedTimeCard;

        const [startHour, startMinute] = utility.timeSpliting(startTime);
        const [endHour, endMinute] = utility.timeSpliting(endTime);
        const [lunchStartHour, lunchStartMinute] = utility.timeSpliting(lunchStartTime);
        const [lunchEndHour, lunchEndMinute] = utility.timeSpliting(lunchEndTime);

        const savedStartTime = checkStartAndEndTime(startTime) ? "" : startTime;
        const savedEndTime = checkStartAndEndTime(endTime) ? "" : endTime;
        const savedLunchStartTime = checkLunchStartAndEndTime(lunchStartTime) ? "" : lunchStartTime;
        const savedLunchEndTime = checkLunchStartAndEndTime(lunchEndTime) ? "" : lunchEndTime;

        return {
            hasData: true,
            onSelectedHours: selectedHours,
            punchesData: {
                startHour, startMinute,
                endHour, endMinute,
                lunchStartHour, lunchStartMinute,
                lunchEndHour, lunchEndMinute,
                savedStartTime, savedEndTime,
                savedLunchStartTime, savedLunchEndTime
            },
        };
    }

    getEmpGroup() {
        let { empGrpList, activeEmpGroupIds, activeIndexForEmpGroup } = this.state;
        let url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.GT_EMP_GRP_M}?deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this, false).then((responseData) => {
            try {
                if (responseData.success) {
                    if (responseData.data && responseData.data.length > 0) {
                        activeEmpGroupIds = responseData.data.map(a => parseInt(a.employeeID));
                        empGrpList = responseData.data.reduce((prev, curr) => {
                            if (curr.groupID) {
                                var previousData = prev.find(a => a.groupID === curr.groupID);
                                if (prev && previousData) {
                                    previousData.groupData = [...previousData.groupData || [], curr];
                                }
                                else {
                                    prev.push({
                                        groupID: curr.groupID,
                                        groupName: curr.groupName,
                                        groupData: [curr],
                                    });
                                }
                                return prev;
                            }
                            else {
                                prev = [];
                                return prev;
                            }
                        }, []);

                        empGrpList.sort((a, b) => {
                            var nameA = a.groupName.toUpperCase();
                            var nameB = b.groupName.toUpperCase();
                            if (nameA < nameB) {
                                return -1;
                            }
                            if (nameA > nameB) {
                                return 1;
                            }
                            //name must be equal
                            return 0;
                        });
                        empGrpList.map(selectedEmp => {
                            selectedEmp.groupData = selectedEmp.groupData.filter(g => g.employeeID != null);
                            selectedEmp.groupData.sort((a, b) => (a.employeeName > b.employeeName) ? 1 : -1)
                        });

                        activeIndexForEmpGroup = empGrpList.map(a => a.groupID);
                        this.setState({ empGrpList, activeEmpGroupIds, activeIndexForEmpGroup }, () => { this.getEmployeeList(); });
                    } else {
                        this.getEmployeeList();
                        this.setState({ empGrpList: [], activeEmpGroupIds: [] });
                    }
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    onClickSelectAllCheckboxForEmpGroup = (e, group) => {
        let { selectedEmployeeList, empGrpList } = this.state;
        var selectedtEmpGroup = empGrpList.find(a => a.groupID === group.groupID);
        selectedtEmpGroup.groupData.map(emp => {
            if (e.checked) {
                if (!selectedEmployeeList.includes(parseInt(emp.employeeID))) {
                    if (selectedEmployeeList.indexOf(parseInt(emp.employeeID)) < 0) {
                        selectedEmployeeList.push(parseInt(emp.employeeID));
                    }
                }
            }
            else {
                var index = selectedEmployeeList.indexOf(parseInt(emp.employeeID));
                index >= 0 && selectedEmployeeList.splice(index, 1);
            }

        });
        this.setState({ selectedEmployeeList, empGrpList });
    }

    getEmployeeList() {
        let { allEmployeeList, activeEmpGroupIds, employeeSearchText, allEmployeeListWithGrp, selectedEmployeeList } = this.state;
        let requestData = (employeeSearchText) ? {
            SearchText: [
                { fieldName: "employeeName", value: employeeSearchText }
            ]
        } : {};
        let url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.GT_AAEP_M}?deviceId=${this.props.device.deviceId}`;
        Api.Post(url, requestData, this, false).then((responseData) => {
            try {
                if (responseData.success && responseData.data) {
                    allEmployeeList = responseData.data.filter(a => !activeEmpGroupIds.includes(a.id));
                    if (!employeeSearchText) {
                        allEmployeeListWithGrp = responseData.data;
                    }
                    selectedEmployeeList = selectedEmployeeList.filter(a =>
                        allEmployeeListWithGrp.some(e => e.id === a)
                    );
                    this.setState({ allEmployeeList, allEmployeeListWithGrp, selectedEmployeeList });
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    handleClickForEmpGrp = (e, titleProps) => {
        const { index } = titleProps;
        const { activeIndexForEmpGroup } = this.state;
        let findIndexOfEmpGroupId = activeIndexForEmpGroup.findIndex(empGroupId => empGroupId === index);
        if (findIndexOfEmpGroupId >= 0) {
            activeIndexForEmpGroup.splice(findIndexOfEmpGroupId, 1);
        } else {
            activeIndexForEmpGroup.push(index)
        }
        this.setState({ activeIndexForEmpGroup });
    }

    goToEmpGroup(groupId) {
        this.props.history.push("/CreateEmpGroup", { groupId: groupId, selectedEmployeeList: this.state.selectedEmployeeList });
    }

    getProjectList(isInitialCall = false) {
        let { assignedProjectNumberList } = this.state;
        let requestData = (this.state.projectSearchText) ? {
            SearchText: [
                { fieldName: "projectName", value: this.state.projectSearchText }
            ]
        } : {};
        let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_AAPBDID_M}?deviceId=${this.props.device.deviceId}`;
        Api.Post(url, requestData, this, false).then((responseData) => {
            try {
                if (responseData.success && responseData.data) {

                    responseData.data.map((prj) => {
                        assignedProjectNumberList.push(prj.projectNumber)
                    });

                    let isSelectedProjectInactive = assignedProjectNumberList.includes(this.state.savedProject.projectNumber);
                    if (!isSelectedProjectInactive) {
                        this.props.timeCardDatas(null, null, this.state.savedHoursValue, this.state.savedStartTime, this.state.savedEndTime, this.state.savedLunchStartTime, this.state.savedLunchEndTime, this.state.savedShift, this.state.savedHoursType);
                        if (this.state.savedProject && this.state.savedTask) {
                            this.props.saveProjectAndTask(this.state.savedProject, this.state.savedTask);
                        }
                        else if (this.state.savedProject) {
                            let task = this.state.savedProject.projectNumber == this.state.savedTask.projectNumber ? this.state.savedTask : "";
                            this.props.saveProjectAndTask(this.state.savedProject, task);
                        }
                        this.setState({
                            savedProject: "", savedTask: ""
                        });
                    }
                    let projectAndTaskData = this.props.projectAndTaskDatas;
                    if (!this.state.savedProject && !this.state.savedTask && projectAndTaskData.savedProject) {
                        let isProjectExist = assignedProjectNumberList.includes(projectAndTaskData.savedProject.projectNumber);
                        if (isProjectExist) {
                            let savedProject = projectAndTaskData.savedProject;
                            let savedTask = projectAndTaskData.savedTask;
                            this.props.timeCardDatas(savedProject, savedTask, this.state.savedHoursValue, this.state.savedStartTime, this.state.savedEndTime, this.state.savedLunchStartTime, this.state.savedLunchEndTime, this.state.savedShift, this.state.savedHoursType);
                            this.setState({ savedProject, savedTask, selectedProject: savedProject, selectedTask: savedTask })
                        }
                    } else {
                        this.props.saveProjectAndTask("", "");
                    }

                    this.setState({ allProjectList: responseData.data, assignedProjectNumberList }, () => { this.getTaskList(isInitialCall); });
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });

    }

    getTaskGroup(isFirstTime = false) {
        let { taskGrpList, activeTaskGroupIds, activeIndexForTaskGroup } = this.state;
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_TSK_GRP_M}?deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this, false).then((responseData) => {
            try {
                if (responseData.success) {
                    if (responseData.data && responseData.data.length > 0) {
                        activeTaskGroupIds = responseData.data.map(a => parseInt(a.taskCodeID));
                        responseData.data.map(data => {
                            data.id = parseInt(data.taskCodeID);
                        });
                        taskGrpList = responseData.data.reduce((prev, curr) => {
                            if (curr.groupID) {
                                var previousData = prev.find(a => a.groupID == curr.groupID);
                                if (prev && previousData) {
                                    previousData.groupData = [...previousData.groupData || [], curr];
                                }
                                else {
                                    prev.push({
                                        groupID: curr.groupID,
                                        groupName: curr.groupName,
                                        groupData: [curr],
                                    });
                                }
                                return prev;
                            }
                            else {
                                prev = [];
                                return prev;
                            }
                        }, []);

                        taskGrpList.sort((a, b) => {
                            var nameA = a.groupName.toUpperCase();
                            var nameB = b.groupName.toUpperCase();
                            if (nameA < nameB) {
                                return -1;
                            }
                            if (nameA > nameB) {
                                return 1;
                            }
                            //name must be equal
                            return 0;
                        });

                        taskGrpList.map(selectedTask => {
                            selectedTask.groupData.sort((a, b) => (a.taskNumber > b.taskNumber) ? 1 : -1)
                        });

                        if (isFirstTime) {
                            activeIndexForTaskGroup = taskGrpList.map(a => a.groupID);
                        }
                        this.setState({ taskGrpList, activeTaskGroupIds, activeIndexForTaskGroup }, () => { this.getTaskList(); });
                    } else {
                        this.getTaskList();
                    }
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    getTaskList(isInitialCall = false) {
        let requestData = (this.state.taskSearchText) ? {
            SearchText: [
                { fieldName: "projectTaskName", value: this.state.taskSearchText }
            ]
        } : {};
        let { savedProject, allTaskList, taskGrpList, tasksNotInSelectedProject, availabelTaskList, allProjectList, savedTask } = this.state;
        savedProject = savedProject ? savedProject : this.props.projectAndTaskDatas.savedProject;
        let availableProject = allProjectList ? allProjectList.find(a => a.id === savedProject.id) : null;
        if (!availableProject) {
            this.setState({ allTaskList: [], selectedTask: "" });
        }
        else if (savedProject) {
            let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_AAPTKBDID_M}?projectId=${savedProject.id}&projectNumber=${savedProject.projectNumber}`;
            Api.Post(url, requestData, this, false).then((responseData) => {
                try {
                    if (responseData.success && responseData.data) {
                        allTaskList = responseData.data;
                        let { selectedGroupTask } = this.state;
                        let searchInGroupTask = selectedGroupTask ? `${selectedGroupTask.taskNumber}${selectedGroupTask.taskName}` : '';
                        if (selectedGroupTask && searchInGroupTask.includes(this.state.taskSearchText) && !allTaskList.find(a => a.taskName === selectedGroupTask.taskName && a.taskNumber === selectedGroupTask.taskNumber)) {
                            allTaskList.unshift(selectedGroupTask);
                        }
                        if (!this.state.taskSearchText) {
                            availabelTaskList = responseData.data;
                            tasksNotInSelectedProject = [];
                            taskGrpList.map(a => {
                                a.groupData.map(t => {
                                    if (!allTaskList.some(b => b.taskName === t.taskName && b.taskNumber === t.taskNumber)) {
                                        tasksNotInSelectedProject.push(t);
                                    }
                                });
                            });
                        }
                        if (isInitialCall && savedTask && !availabelTaskList.find(b => b.taskName === savedTask.taskName && b.taskNumber === savedTask.taskNumber)) {
                            savedTask = "";
                        }
                        this.setState({ allTaskList, tasksNotInSelectedProject, availabelTaskList, savedTask });
                    }
                    else {
                        MessageBox(responseData.message, Constants.ERROR);
                    }
                }
                catch (err) {
                    MessageBox(err.message, Constants.ERROR);
                }
            });
        }
    }

    handleClickForTaskGrp = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndexForTaskGroup } = this.state
        let findIndexOfTaskGroupId = activeIndexForTaskGroup.findIndex(taskGroupId => taskGroupId === index);
        if (findIndexOfTaskGroupId >= 0) {
            activeIndexForTaskGroup.splice(findIndexOfTaskGroupId, 1);
        } else {
            activeIndexForTaskGroup.push(index)
        }
        this.setState({ activeIndexForTaskGroup });
    }

    goToTaskCodeGroup(groupId) {
        let { savedProject, selectedTab } = this.state;
        this.props.onTabSelect(selectedTab);
        this.props.history.push("/CreateTaskGroup", { groupId: groupId, projectId: savedProject.id, projectNumber: savedProject.projectNumber, selectedTask: this.state.selectedTask, selectedEmployeeList: this.state.selectedEmployeeList });
    }

    onTabSelect(tab, isFirstTime = false) {
        let { employeeSearchText, previousTab, savedTask, savedProject, selectedTask, selectedProject, taskSearchText, projectSearchText, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute } = this.state;
        if (tab === 'project') {
            // employeeSearchText= "";
            taskSearchText = "";
            previousTab = "";

        }
        else if (tab === 'taskcodes') {
            //  employeeSearchText= "";
            projectSearchText = "";
            previousTab = "";
        }
        else if (tab === 'starttimeandtunchtime') {
            employeeSearchText = "";
            projectSearchText = "";
            taskSearchText = "";
            [startHour, startMinute] = utility.timeSpliting(savedStartTime);
            [endHour, endMinute] = utility.timeSpliting(savedEndTime);
            [lunchStartHour, lunchStartMinute] = utility.timeSpliting(savedLunchStartTime);
            [lunchEndHour, lunchEndMinute] = utility.timeSpliting(savedLunchEndTime);
            previousTab = "";
        }
        else {
            projectSearchText = "";
            taskSearchText = "";
        }
        if (tab !== 'project') {
            selectedProject = savedProject;
        }
        if (tab !== 'taskcodes') {
            if (savedTask && savedProject && savedProject.projectNumber === savedTask.projectNumber) {
                selectedTask = savedTask;
            }
            else {
                selectedTask = "";
            }
        }
        this.setState({ selectedTab: tab, previousTab, selectedProject, selectedTask, employeeSearchText, taskSearchText, projectSearchText, startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute }, () => {
            if (tab === 'project') {
                this.getProjectList();
            }
            else if (tab === 'taskcodes') {
                this.getProjectList();
                this.getTaskGroup(isFirstTime);
            }
            else if (tab !== 'starttimeandtunchtime') {
                this.getEmployeeList();
                this.getEmpGroup();
            }
        });
    }

    onClickCreateTeam() {
        this.props.history.push("/CreateEmpGroup", { selectedEmployeeList: this.state.selectedEmployeeList });
    }

    onClickBack(backfrom) {
        let { selectedTab, savedTask, savedProject, selectedTask } = this.state;
        if (backfrom === 'project') {
            selectedTab = "";
        }
        else if (backfrom === 'taskcodes') {
            if (savedTask && selectedTask && selectedTask.projectNumber === savedTask.projectNumber) {
                selectedTask = savedTask;
            }
            else {
                selectedTask = "";
            }
            selectedTab = 'project';
        }
        else if (backfrom === "") {
            this.props.history.push("/Timecard");
        }
        else {
            this.getEmployeeList();
        }

        this.setState({ selectedTab, selectedTask, selectedProject: savedProject },
            () => {
                this.onTabSelect(this.state.selectedTab);
            });
    }

    async onClickSave() {
        let { selectedEmployeeList, deviceName, selectedDate, availabelTaskList, allEmployeeListWithGrp, savedProject, savedTask, selectedProject, selectedTask, savedShift, savedHoursType, savedHoursValue, selectedTab, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime } = this.state;

        const isTaskAndProject = selectedTab === "" && selectedEmployeeList.length > 0 && savedProject && savedTask;
        const selectedHours = parseFloat(savedHoursValue);

        const startTme = (!savedStartTime || savedStartTime === Constants.NOT_APPLICABLE) ? '' : savedStartTime.replace(':', '.');
        const endTme = (!savedEndTime || savedEndTime === Constants.NOT_APPLICABLE) ? '' : savedEndTime.replace(':', '.');
        const lunchStartTme = (!savedLunchStartTime || savedLunchStartTime === Constants.NOT_APPLICABLE) ? '' : savedLunchStartTime.replace(':', '.');
        const lunchEndTme = (!savedLunchEndTime || savedLunchEndTime === Constants.NOT_APPLICABLE) ? '' : savedLunchEndTime.replace(':', '.');

        if (isTaskAndProject) {
            if (CheckEnterHours(selectedHours) && (!startTme || !endTme || !lunchStartTme || !lunchEndTme)) {
                MessageBox(Constants.REQUIRE_ALL_PUNCHES, Constants.ERROR);
                return;
            }
            if (selectedHours > 0 && (!startTme || !endTme)) {
                MessageBox(Constants.ENTER_START_TIME_AND_END_TIME, Constants.ERROR);
                return;
            }
            if (selectedHours > 0) {
                if (parseFloat(endTme) == parseFloat(startTme)) {
                    MessageBox(Constants.SAME_TIME_VALIDATION, Constants.ERROR);
                    return;
                }
                if (lunchStartTme !== Constants.NOT_APPLICABLE && lunchEndTme !== Constants.NOT_APPLICABLE && (parseFloat(lunchStartTme) == parseFloat(lunchEndTme))) {
                    MessageBox(Constants.LUNCH_SAME_TIME_VALIDATION, Constants.ERROR);
                    return;
                }
            }
        }

        if (!selectedTab && selectedEmployeeList.length > 0) {
            if (!savedProject) {
                this.onTabSelect('project');
                return;
            }
            if (savedProject && !savedTask) {
                this.onTabSelect('taskcodes', true);
                return;
            }
        }

        let taskInProject = availabelTaskList.find(a => a.projectNumber === selectedProject.projectNumber && a.taskNumber === selectedTask.taskNumber);
        taskInProject = taskInProject ? taskInProject : "";
        if (selectedTab === 'project' && selectedProject) {
            savedProject = selectedProject;
            if (savedTask && savedProject && savedProject.projectNumber === savedTask.projectNumber) {
                selectedTask = savedTask;
            } else if (selectedTask === "" && this.props.timeCard.taskCode && savedProject.projectNumber === this.props.timeCard.taskCode.projectNumber) {
                selectedTask = this.props.timeCard.taskCode;
                savedTask = this.props.timeCard.taskCode;
            } else {
                selectedTask = "";
            }

            this.setState({ savedProject, savedTask, selectedTask }, () => {
                this.props.timeCardDatas(savedProject, savedTask, savedHoursValue, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, savedShift, savedHoursType);
                this.onTabSelect('taskcodes', true);
            });
        } else if (selectedTab === 'taskcodes' && selectedTask && taskInProject) {
            savedTask = availabelTaskList.find(a => a.taskNumber === selectedTask.taskNumber && a.taskName === selectedTask.taskName);
            this.setState({ savedTask }, () => {
                this.props.timeCardDatas(savedProject, savedTask, savedHoursValue, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, savedShift, savedHoursType);
                this.onTabSelect("");
            });
            return;
        }

        if (!selectedTab && selectedEmployeeList.length === 0) {
            MessageBox(Constants.SELECT_EMPLOYEE, Constants.ERROR);
            return;
        }

        if (selectedTab === 'project' && !savedProject) {
            MessageBox(Constants.TIMECARD_PLEASE_SELECT_PROJECT, Constants.ERROR);
            return;
        }

        if ((selectedTab === 'taskcodes' || selectedTab === "") && savedProject && !taskInProject) {
            MessageBox(Constants.SELECT_VALID_TASK_CODE, Constants.ERROR);
            return;
        }

        if (selectedTab === "" && savedHoursType === Constants.ST && parseInt(savedHoursValue) > 10) {
            MessageBox(Constants.ST_HOURS_CANNOT_BE_GREATER, Constants.ERROR);
            return;
        }

        const datePicked = new Date(selectedDate);
        const startTime = new Date(datePicked.setHours(0, 0, 0));
        const startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        const tomorrow = new Date(selectedDate);
        const endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        const endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        const dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        const selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        const dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        const timeZone = startDate.toString();
        const selectTimeZone = timeZone.slice(16, 24);
        const fromDate = `${selectDate} ${selectTimeZone}`;
        const toDate = `${dateSelected} ${selectTimeZone}`;

        const requestData = [];

        if (selectedTab === "" && selectedEmployeeList.length > 0 && savedProject && savedTask && savedShift && savedHoursType && savedStartTime && savedHoursValue && (savedHoursValue <= 4 || (savedHoursValue > 4 && savedEndTime))) {
            this.setState({ disableSaveButton: true }, () => {
                // get current date
                const current = new Date(selectedDate);
                // var monday = (new Date(current.setDate(current.getDate() - current.getDay() + (current.getDay() == 0 ? -6 : 1))));
                const sunday = (new Date(current.setDate(current.getDate() + (current.getDay() === 0 ? 0 : 7 - current.getDay()))));
                selectedEmployeeList.forEach(a => {
                    const emp = allEmployeeListWithGrp.find(e => e.id === parseInt(a));
                    requestData.push({
                        createdDate: new Date(selectedDate),
                        creationDate: new Date(),
                        modifiedDate: new Date(),
                        CreatedBy: Constants.ROSENDINTIME_USER,
                        ModifiedBy: Constants.ROSENDINTIME_USER,
                        employeeID: emp.id,
                        employeeName: emp.fullName,
                        employeeNumber: emp.employeeNumber,
                        projectId: savedProject.id,
                        projectNumber: savedProject.projectNumber,
                        projectName: savedProject.projectName,
                        taskCodeID: savedTask ? savedTask.id : '',
                        taskNumber: savedTask ? savedTask.taskNumber : '',
                        taskName: savedTask ? `${savedTask.taskNumber} - ${savedTask.taskName}` : '',
                        deviceId: this.props.device.deviceId,
                        deviceName: deviceName,
                        submittedByEmployeeId: this.props.user.employeeId,
                        actualUnits: 0,
                        expectationalUnits: 0,
                        hours: Number(savedHoursValue).toString(),
                        day: new Date(selectedDate).getDay() == 0 ? new Date(selectedDate).getDay() + 7 : new Date(selectedDate).getDay(),
                        selectedDate: '',
                        iNTStatus: Constants.IN_PROGRESS,
                        workDoneAtJobSite: this.state.workDone[0].title,
                        shift: savedShift,
                        hoursType: Number(savedHoursValue) === 0 ? this.getHoursTypeCode(savedShift, Constants.ST) : this.getHoursTypeCode(savedShift, savedHoursType),
                        weekEndingDate: moment(sunday).format("MM/DD/YYYY"),
                        // timeRecordHourList: [],
                        // attachmentList: [],
                        startTime: savedStartTime,
                        endTime: savedEndTime,
                        lunchStartTime: savedLunchStartTime,
                        lunchEndTime: savedLunchEndTime,
                        isSelectedTaskCode: false,
                        fromDate: fromDate,
                        toDate: toDate
                    });
                });
                if (requestData && requestData.length > 0) {
                    const url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.SVE_TIME_CARD_DETLS_M}`;
                    Api.Post(url, requestData, this).then(responseData => {
                        if (responseData.success) {
                            this.props.groupByInTimecardPage('');
                            this.props.history.push("/Timecard");
                        } else {
                            if (responseData.data?.isTimeCardAttested) {
                                this.setState({ isShowAlreadyAttestedModal: true, disableSaveButton: false });
                            } else {
                                this.setState({ disableSaveButton: false });
                                MessageBox(responseData.message, Constants.ERROR);
                            }
                        }
                    }).catch((error) => {
                        MessageBox(error, Constants.ERROR);
                        this.setState({ disableSaveButton: false });
                    });
                }
            });
        }
    }

    onEmployeeSearch(event) {
        this.setState({ employeeSearchText: event.target.value },
            () => {
                this.onTabSelect(this.state.selectedTab);
            });
    }

    onTaskSearch(event) {
        this.setState({ taskSearchText: event.target.value, isSelectedTaskCode: false },
            () => {
                this.onTabSelect(this.state.selectedTab);
            });
    }

    onProjectSearch(event) {
        this.setState({ projectSearchText: event.target.value },
            () => {
                this.onTabSelect(this.state.selectedTab);
            });
    }

    getHoursTypeCode(shift, hoursType) {
        switch (shift) {
            case Constants.EVENING:
                if (hoursType === Constants.ST)
                    return Constants.ST2;
                else if (hoursType === Constants.OT)
                    return Constants.OT2;
                else
                    return hoursType;
            case Constants.NIGHT:
                if (hoursType === Constants.ST)
                    return Constants.ST3;
                else if (hoursType === Constants.OT)
                    return Constants.OT3;
                else
                    return hoursType;
            case Constants.DAY:
                return hoursType;
            default:
                break;
        }
    }

    onEmployeeSelect(e, data) {
        let { selectedEmployeeList } = this.state;
        if (data.checked) {
            selectedEmployeeList.push(Number(data.value));
        }
        else {
            var index = selectedEmployeeList.indexOf(Number(data.value));
            selectedEmployeeList.splice(index, 1);
        }
        this.setState({ selectedEmployeeList });
    }

    onProjectSelect(e, { value }) {
        this.setState({ selectedProject: value });
    }

    onTaskCodeSelect(value, isFromGroup = false) {
        let { allTaskList, selectedGroupTask } = this.state;
        if (!allTaskList.find(a => a.taskName === value.taskName && a.taskNumber === value.taskNumber) && isFromGroup) {
            allTaskList.unshift(value);
            selectedGroupTask = value;
        }
        this.setState({ selectedTask: value, isSelectedTaskCode: true, selectedGroupTask });
    }

    onClickShiftModel() {

        this.setState({
            isSelectShiftModelVisible: true, previousTab: "shift", onSelectedShift: this.state.savedShift
        });
    }

    onClickHoursTypeModel() {
        this.setState({
            isHoursTypeModelVisible: true, previousTab: "hoursType", onSelectedHoursType: this.state.savedHoursType
        });
    }

    onCloseShiftModel() {
        const { onSelectedShift, savedShift } = this.state;

        if (onSelectedShift !== savedShift) {
            this.onConfirmationOpen();
        } else {
            this.onGoBack();
        }
    }

    onCloseHoursTypeModel() {
        const { onSelectedHoursType, savedHoursType } = this.state;

        if (onSelectedHoursType !== savedHoursType) {
            this.onConfirmationOpen();
        } else {
            this.onGoBack();
        }
    }

    onCloseHoursModel() {
        const { onSelectedHours, savedHoursValue } = this.state;

        if (onSelectedHours !== savedHoursValue) {
            this.onConfirmationOpen();
        } else {
            this.onGoBack();
        }
    }

    onGoBack() {
        this.setState({
            isConfirmationModelVisible: false,
            isSelectShiftModelVisible: false,
            isHoursModelVisible: false,
            isHoursTypeModelVisible: false,
            ...this.state.initialPunches
        }, () => {
            if (this.props.location?.state?.isFromTimeCard) {
                this.props.history.push("/TimeCard");
            } else {
                this.onTabSelect("");
            }
        });
    }

    onClickHoursModel() {
        this.setState({
            isHoursModelVisible: true, previousTab: "hours", onSelectedHours: this.state.savedHoursValue
        });
    }

    onShiftSelect(e, { value }) {
        this.setState({ onSelectedShift: value });
    }

    onHoursTypeSelect(e, { value }) {
        this.setState({ onSelectedHoursType: value });
    }

    onChangeHours(event) {
        const value = event.target.value;

        if (!isNaN(value)) {
            this.setState({ onSelectedHours: value });
        }
    }

    onSaveHours() {
        let { onSelectedHours, savedHoursType, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute, initialPunches } = this.state;
        onSelectedHours = utility.hoursFormation(onSelectedHours);
        const lastStartTime = this.props?.punches?.lastStartTime ?? "";
        const lastEndTime = this.props?.punches?.lastEndTime ?? "";
        const lastLunchStartTime = this.props?.punches?.lastLunchStartTime ?? "";
        const lastLunchEndTime = this.props?.punches?.lastLunchEndTime ?? "";

        if (!onSelectedHours) {
            MessageBox(Constants.PLEASE_ENTER_HOURS, Constants.ERROR);
            return;
        }
        if (onSelectedHours > 10 && savedHoursType === 'ST') {
            MessageBox(Constants.ENTERED_HOURS_SHOULD_NOT_EXCEED, Constants.ERROR);
            return;
        }
        if (Number(onSelectedHours) === 0) {
            savedStartTime = Constants.NOT_APPLICABLE;
            savedEndTime = Constants.NOT_APPLICABLE;
            savedLunchStartTime = Constants.NOT_APPLICABLE;
            savedLunchEndTime = Constants.NOT_APPLICABLE;
            startHour = '';
            startMinute = '';
            endHour = '';
            endMinute = '';
            lunchStartHour = '';
            lunchStartMinute = '';
            lunchEndHour = '';
            lunchEndMinute = '';
        } else {
            if (lastStartTime && lastEndTime && lastLunchStartTime && lastLunchEndTime) {
                savedStartTime = lastStartTime;
                savedEndTime = lastEndTime;
                savedLunchStartTime = lastLunchStartTime;
                savedLunchEndTime = lastLunchEndTime;
            }
        }
        this.setState({ savedHoursValue: onSelectedHours, isHoursModelVisible: false, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute, initialPunches: { savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime } });

        // Commented for Phase-6 Task - Lunch time doesn't always stay for the next day. Times should stay

        // if (onSelectedHours <= 4) {
        //     this.props.timeCardDatas(this.state.savedProject, this.state.savedTask, onSelectedHours, this.state.savedStartTime, "",this.state.savedShift,savedHoursType);
        //     this.setState({
        //         endTime: "", savedEndTime: ""
        //     });
        // }
        // else {
        //     this.props.timeCardDatas(this.state.savedProject, this.state.savedTask, onSelectedHours, this.state.savedStartTime, this.state.savedEndTime,this.state.savedShift,savedHoursType);
        // }

        this.props.timeCardDatas(this.state.savedProject, this.state.savedTask, onSelectedHours, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, this.state.savedShift, savedHoursType);
    }

    onSaveShift() {
        let { savedProject, savedTask, onSelectedHours, onSelectedShift, savedHoursType, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime } = this.state;
        this.setState({ savedShift: onSelectedShift, isSelectShiftModelVisible: false });
        this.props.timeCardDatas(savedProject, savedTask, onSelectedHours, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, onSelectedShift, savedHoursType);
    }

    onSaveHoursType() {
        let { savedProject, savedTask, onSelectedHours, onSelectedHoursType, savedShift, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime } = this.state;
        this.setState({ savedHoursType: onSelectedHoursType, isHoursTypeModelVisible: false });
        this.props.timeCardDatas(savedProject, savedTask, onSelectedHours, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, savedShift, onSelectedHoursType);
    }

    onBackStartTimeLunchTime() {
        let { savedProject, savedTask, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, initialPunches } = this.state;

        const savedPunches = {
            savedStartTime,
            savedEndTime,
            savedLunchStartTime,
            savedLunchEndTime
        };

        if (savedProject.projectNumber !== savedTask.projectNumber) {
            savedTask = '';
        }

        this.setState({ savedTask }, () => {
            if (!_.isEqual(savedPunches, initialPunches)) {
                this.onConfirmationOpen();
            } else {
                this.onGoBack();
            }
        });
    }

    validatePunches(selectedHours) {
        const { startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute } = this.state;
        const HOUR_THRESHOLD = 23;
        const MINUTE_THRESHOLD = 59;
        const isFourPointFiveHours = CheckEnterHours(selectedHours)
        const allHours = [startHour, endHour, lunchStartHour, lunchEndHour].map(a => Number(a));
        const allMinutes = [startMinute, endMinute, lunchStartMinute, lunchEndMinute].map(a => Number(a));
        const hoursAndMinutes = [startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute];
        const lunchPunches = [lunchStartHour, lunchEndHour, lunchStartMinute, lunchEndMinute];

        // StartTime Validation
        if (selectedHours !== 0 && (!startHour || !startMinute)) {
            MessageBox(Constants.INVALID_START_TIME, Constants.ERROR);
            return;
        }

        if (selectedHours !== 0 && (!endHour || !endMinute)) {
            MessageBox(Constants.INVALID_END_TIME, Constants.ERROR);
            return;
        }

        if (allHours.some(a => a > HOUR_THRESHOLD)) {
            MessageBox(Constants.PLEASE_ENTER_VALID_HOURS, Constants.ERROR);
            return;
        }

        if (allMinutes.some(a => a > MINUTE_THRESHOLD)) {
            MessageBox(Constants.PLEASE_ENTER_VALID_MINUTES, Constants.ERROR);
            return;
        }

        // LunchTime Validation
        if ((!lunchStartHour && lunchStartMinute) || (lunchStartHour && !lunchStartMinute)) {
            MessageBox(Constants.INVALID_LUNCH_START_TIME, Constants.ERROR);
            return;
        }

        if ((!lunchEndHour && lunchEndMinute) || (lunchEndHour && !lunchEndMinute)) {
            MessageBox(Constants.INVALID_LUNCH_END_TIME, Constants.ERROR);
            return;
        }

        if (lunchStartHour && lunchStartMinute && !lunchEndHour && !lunchEndMinute) {
            MessageBox(Constants.ENTER_LUNCH_END_TIME, Constants.ERROR);
            return;
        }

        if (lunchEndHour && lunchEndMinute && !lunchStartHour && !lunchStartMinute) {
            MessageBox(Constants.ENTER_LUNCH_START_TIME, Constants.ERROR);
            return;
        }

        if (selectedHours === 0 && hoursAndMinutes.some(a => a !== "")) {
            this.setState({ isSaveButtonDisabled: false });
            MessageBox(Constants.PLEASE_ENTER_NA, Constants.ERROR);
            return;
        }

        if (isFourPointFiveHours) {
            if (lunchPunches.some(a => !a)) {
                MessageBox(Constants.ENTER_LUNCH_START_TIME_AND_LUNCH_END_TIME, Constants.ERROR);
                return;
            }

            if (hoursAndMinutes.some(a => !a)) {
                MessageBox(Constants.REQUIRE_ALL_PUNCHES, Constants.ERROR);
                return;
            }
        }

        if (selectedHours > 0) {
            const { savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime } = this.convertPunchesToHHMM();
            const startTme = savedStartTime.replace(":", ".");
            const endTme = savedEndTime.replace(":", ".");
            const lunchStartTme = savedLunchStartTime.replace(":", ".");
            const lunchEndTme = savedLunchEndTime.replace(":", ".");
            if (parseFloat(endTme) == parseFloat(startTme)) {
                MessageBox(Constants.SAME_TIME_VALIDATION, Constants.ERROR);
                return;
            }
            if (lunchStartTme !== Constants.NOT_APPLICABLE && lunchEndTme !== Constants.NOT_APPLICABLE && (parseFloat(lunchStartTme) === parseFloat(lunchEndTme))) {
                this.setState({ isSaveButtonDisabled: false });
                MessageBox(Constants.LUNCH_SAME_TIME_VALIDATION, Constants.ERROR);
                return;
            }
            if (startTme !== Constants.NOT_APPLICABLE && lunchStartTme !== Constants.NOT_APPLICABLE && (parseFloat(startTme) === parseFloat(lunchStartTme))) {
                this.setState({ isSaveButtonDisabled: false });
                MessageBox(Constants.START_AND_LUNCH_START_TIME_VALIDATION, Constants.ERROR);
                return;
            }
            if (endTme !== Constants.NOT_APPLICABLE && lunchEndTme !== Constants.NOT_APPLICABLE && (parseFloat(endTme) === parseFloat(lunchEndTme))) {
                this.setState({ isSaveButtonDisabled: false });
                MessageBox(Constants.END_AND_LUNCH_END_TIME_VALIDATION, Constants.ERROR);
                return;
            }
            if (startTme !== Constants.NOT_APPLICABLE && lunchEndTme !== Constants.NOT_APPLICABLE && (parseFloat(startTme) === parseFloat(lunchEndTme))) {
                this.setState({ isSaveButtonDisabled: false });
                MessageBox(Constants.START_AND_LUNCH_END_TIME_VALIDATION, Constants.ERROR);
                return;
            }
            if (endTme !== Constants.NOT_APPLICABLE && lunchStartTme !== Constants.NOT_APPLICABLE && (parseFloat(endTme) === parseFloat(lunchStartTme))) {
                this.setState({ isSaveButtonDisabled: false });
                MessageBox(Constants.END_AND_LUNCH_START_TIME_VALIDATION, Constants.ERROR);
                return;
            }
        }

        return true;
    }

    convertPunchesToHHMM() {
        const { startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute } = this.state;
        const savedStartTime = utility.convertToHHMM(`${startHour}:${startMinute}`);
        const savedEndTime = utility.convertToHHMM(`${endHour}:${endMinute}`);
        const savedLunchStartTime = (lunchStartHour && lunchStartMinute) ? utility.convertToHHMM(`${lunchStartHour}:${lunchStartMinute}`) : Constants.NOT_APPLICABLE;
        const savedLunchEndTime = (lunchEndHour && lunchEndMinute) ? utility.convertToHHMM(`${lunchEndHour}:${lunchEndMinute}`) : Constants.NOT_APPLICABLE;
        return { savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime };
    }

    onSaveStartTimeLunchTime() {
        let { groupBy, savedProject, savedTask, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, onSelectedHours, isFromTimeCard } = this.state;
        const selectedHours = parseFloat(onSelectedHours);
        let lastStartTime = this.props?.punches?.lastStartTime ?? "";
        let lastEndTime = this.props?.punches?.lastEndTime ?? "";
        let lastLunchStartTime = this.props?.punches?.lastLunchStartTime ?? "";
        let lastLunchEndTime = this.props?.punches?.lastLunchEndTime ?? "";

        if (!this.validatePunches(selectedHours)) {
            return;
        }

        if (selectedHours > 0) {
            ({ savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime } = this.convertPunchesToHHMM());
        }

        if (selectedHours === 0) {
            savedStartTime = Constants.NOT_APPLICABLE;
            savedEndTime = Constants.NOT_APPLICABLE;
            savedLunchStartTime = Constants.NOT_APPLICABLE;
            savedLunchEndTime = Constants.NOT_APPLICABLE;
        }

        if (!savedLunchStartTime || !savedLunchEndTime) {
            savedLunchStartTime = Constants.NOT_APPLICABLE;
            savedLunchEndTime = Constants.NOT_APPLICABLE;
        }

        if (selectedHours > 0 && !isFromTimeCard) {
            lastStartTime = savedStartTime;
            lastEndTime = savedEndTime;
            lastLunchStartTime = savedLunchStartTime;
            lastLunchEndTime = savedLunchEndTime;
            this.props.timeCardPunches(lastStartTime, lastEndTime, lastLunchStartTime, lastLunchEndTime);
        }

        if (savedProject.projectNumber !== savedTask.projectNumber) {
            savedTask = '';
        }

        this.setState({ savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, savedTask }, () => {
            let { timeCardDataFromTCPage, isFromTimeCard } = this.state;
            let requestData = [];
            if (isFromTimeCard) {
                let datePicked = new Date(this.state.selectedDate);
                let startTime = new Date(datePicked.setHours(0, 0, 0));
                let startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
                let tomorrow = new Date(this.state.selectedDate);
                let endTime = tomorrow.setDate(tomorrow.getDate() + 1);
                let endDate = new Date(endTime);
                endDate.setHours(0, 0, 0);
                let dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
                let selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
                let dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
                let timeZone = startDate.toString();
                let selectTimeZone = timeZone.slice(16, 24);
                let fromDate = `${selectDate} ${selectTimeZone}`;
                let toDate = `${dateSelected} ${selectTimeZone}`;
                let timeCardData = groupBy === Constants.PROJECT ? timeCardDataFromTCPage : timeCardDataFromTCPage.timecardData[0];
                timeCardData.startTime = savedStartTime;
                timeCardData.endTime = savedEndTime;
                timeCardData.lunchStartTime = savedLunchStartTime;
                timeCardData.lunchEndTime = savedLunchEndTime;
                timeCardData.fromDate = fromDate;
                timeCardData.toDate = toDate;
                requestData.push(timeCardData);

                const url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.CRTE_OR_UPDE_TMECRDS}?isFromStartAndLunchTime=${true}`;
                Api.Post(url, requestData, this).then((responseData) => {
                    if (responseData.success) {
                        this.props.history.push("/TimeCard");
                    } else {
                        MessageBox(responseData.message, Constants.ERROR);
                    }

                }).catch(err => {
                    this.setState({ isSaveButtonDisabled: false, isShowLoader: false });
                    MessageBox(err, Constants.ERROR);
                });
            } else {
                this.setState({ initialPunches: { savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime } });
                this.props.timeCardDatas(this.state.savedProject, this.props.timeCard.taskCode, this.state.savedHoursValue, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, this.state.savedShift, this.state.savedHoursType);
                this.onTabSelect("");
            }
        }
        );
    }

    validateAndFocusInput(value, inputValue, prevRef, nextRef) {
        if (inputValue.length <= 2) {
            value = this.getHoursValue(inputValue);
        }
        if (prevRef.current && value.length === 0 && !isNaN(inputValue)) {
            prevRef.current.focus();
        } else if (nextRef.current && (value.length == 2 || inputValue.length === 3)) {
            nextRef.current.focus();
        }
        return value;
    }

    onChangePunches(inputValue, inputName) {
        let { startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute, startHourInputRef, startMinuteInputRef, endHourInputRef, endMinuteInputRef, lunchStartHourInputRef, lunchStartMinuteInputRef, lunchEndHourInputRef, lunchEndMinuteInputRef, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime } = this.state;
        switch (inputName) {
            case Constants.START_HOUR:
                startHour = this.validateAndFocusInput(startHour, inputValue, startHourInputRef, startMinuteInputRef);
                break;
            case Constants.START_MINUTES:
                startMinute = this.validateAndFocusInput(startMinute, inputValue, startHourInputRef, endHourInputRef);
                break;
            case Constants.END_HOUR:
                endHour = this.validateAndFocusInput(endHour, inputValue, startMinuteInputRef, endMinuteInputRef);
                break;
            case Constants.END_MINUTES:
                endMinute = this.validateAndFocusInput(endMinute, inputValue, endHourInputRef, lunchStartHourInputRef);
                break;
            case Constants.LUNCH_START_HOUR:
                lunchStartHour = this.validateAndFocusInput(lunchStartHour, inputValue, endMinuteInputRef, lunchStartMinuteInputRef);
                break;
            case Constants.LUNCH_START_MINUTES:
                lunchStartMinute = this.validateAndFocusInput(lunchStartMinute, inputValue, lunchStartHourInputRef, lunchEndHourInputRef);
                break;
            case Constants.LUNCH_END_HOUR:
                lunchEndHour = this.validateAndFocusInput(lunchEndHour, inputValue, lunchStartMinuteInputRef, lunchEndMinuteInputRef);
                break;
            case Constants.LUNCH_END_MINUTES:
                lunchEndMinute = this.validateAndFocusInput(lunchEndMinute, inputValue, lunchEndHourInputRef, lunchEndMinuteInputRef);
                break;
        }

        const formatTime = (a) => a.length === 1 && a === ":" ? '' : a;
        if (inputName === Constants.START_HOUR || inputName === Constants.START_MINUTES) {
            savedStartTime = formatTime(utility.convertToHHMM(`${startHour}:${startMinute}`));
        } else if (inputName === Constants.END_HOUR || inputName === Constants.END_MINUTES) {
            savedEndTime = formatTime(utility.convertToHHMM(`${endHour}:${endMinute}`));
        } else if (inputName === Constants.LUNCH_START_HOUR || inputName === Constants.LUNCH_START_MINUTES) {
            savedLunchStartTime = formatTime(utility.convertToHHMM(`${lunchStartHour}:${lunchStartMinute}`));
        } else if (inputName === Constants.LUNCH_END_HOUR || inputName === Constants.LUNCH_END_MINUTES) {
            savedLunchEndTime = formatTime(utility.convertToHHMM(`${lunchEndHour}:${lunchEndMinute}`));
        }
        this.setState({ startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute, savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime });
    }

    onClickNA(inputName, isNASelected) {
        let { savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute, onSelectedHours } = this.state;
        if (Number(onSelectedHours) === 0 && isNASelected) return;
        const onToggleNA = (value) => value === Constants.NOT_APPLICABLE ? '' : Constants.NOT_APPLICABLE;
        const clearTime = (isLunch = false) => {
            if (isLunch) {
                lunchStartHour = '';
                lunchStartMinute = '';
                lunchEndHour = '';
                lunchEndMinute = '';
            } else {
                startHour = '';
                startMinute = '';
                endHour = '';
                endMinute = '';
            }
        };
        switch (inputName) {
            case Constants.START_TIME:
                clearTime();
                savedStartTime = onToggleNA(savedStartTime);
                savedEndTime = onToggleNA(savedEndTime);
                break;
            case Constants.END_TIME:
                clearTime();
                savedStartTime = onToggleNA(savedStartTime);
                savedEndTime = onToggleNA(savedEndTime);
                break;
            case Constants.LUNCH_START_TIME:
                clearTime(true);
                savedLunchStartTime = onToggleNA(savedLunchStartTime);
                savedLunchEndTime = onToggleNA(savedLunchEndTime);
                break;
            case Constants.LUNCH_END_TIME:
                clearTime(true);
                savedLunchStartTime = onToggleNA(savedLunchStartTime);
                savedLunchEndTime = onToggleNA(savedLunchEndTime);
                break;
        }
        this.setState({ savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute });
    }

    getHoursValue(e) {
        e = e.trim();
        let hour = (typeof (e) === "string" && e.replace(/[^0-9]/g, '') ? e.replace(/[^0-9]/g, '') : '');
        return hour;
    }

    onConfirmationOpen() {
        this.setState({ isConfirmationModelVisible: true });
    }

    onConfirmationCancel() {
        this.onGoBack();
    }

    onConfirmationYes() {
        let { isSelectShiftModelVisible, isHoursTypeModelVisible, isHoursModelVisible } = this.state;

        this.setState({
            isConfirmationModelVisible: false
        }, () => {
            if (isSelectShiftModelVisible) {
                this.onSaveShift();
            }
            else if (isHoursTypeModelVisible) {
                this.onSaveHoursType();
            }
            else if (isHoursModelVisible) {
                this.onSaveHours();
            }
            else {
                this.onSaveStartTimeLunchTime();
            }
        });
    }

    onClickCreateTaskCodeGroupTeam() {
        let { savedProject, selectedTab } = this.state;
        this.props.onTabSelect(selectedTab);
        this.props.history.push("/CreateTaskGroup", { projectId: savedProject.id, projectNumber: savedProject.projectNumber, selectedTask: this.state.selectedTask, selectedEmployeeList: this.state.selectedEmployeeList });
    }

    onCloseAlreadyAttestModal() {
        this.setState({ isShowAlreadyAttestedModal: false, disableSaveButton: false });
    }

    render() {
        const { isSelectShiftModelVisible, isHoursTypeModelVisible, isConfirmationModelVisible, onSelectedShift, onSelectedHoursType, savedProject, savedTask, savedShift, savedHoursType, onSelectedHours, savedHoursValue, isHoursModelVisible,
            allEmployeeList, allProjectList, allTaskList, selectedTab, selectedEmployeeList, selectedProject, selectedTask, employeeSearchText, projectSearchText, taskSearchText,
            empGrpList, activeIndexForEmpGroup, taskGrpList, activeIndexForTaskGroup, isShowLoader, assignedProjectNumberList, previousTab, tasksNotInSelectedProject, isSelectedTaskCode,
            savedStartTime, savedEndTime, savedLunchStartTime, savedLunchEndTime, startHour, startMinute, endHour, endMinute, lunchStartHour, lunchStartMinute, lunchEndHour, lunchEndMinute, startHourInputRef, startMinuteInputRef, endHourInputRef, endMinuteInputRef,
            lunchStartHourInputRef, lunchStartMinuteInputRef, lunchEndHourInputRef, lunchEndMinuteInputRef, isShowAlreadyAttestedModal, timeCardDataFromTCPage, disableSaveButton } = this.state;
        return (
            <Fragment>
                <EmployeeComponent
                    {...{
                        employee: {
                            allEmployeeList,
                            allProjectList,
                            allTaskList,
                            selectedTab,
                            selectedEmployeeList,
                            selectedProject,
                            selectedTask,
                            employeeSearchText,
                            projectSearchText,
                            taskSearchText,
                            onSelectedShift,
                            onSelectedHoursType,
                            savedShift,
                            savedHoursType,
                            onSelectedHours,
                            savedHoursValue,
                            isSelectShiftModelVisible,
                            isHoursTypeModelVisible,
                            isHoursModelVisible,
                            savedProject,
                            savedTask,
                            empGrpList,
                            activeIndexForEmpGroup,
                            taskGrpList,
                            activeIndexForTaskGroup,
                            isShowLoader,
                            isConfirmationModelVisible,
                            assignedProjectNumberList,
                            previousTab,
                            tasksNotInSelectedProject,
                            isSelectedTaskCode,

                            savedStartTime,
                            savedEndTime,
                            savedLunchStartTime,
                            savedLunchEndTime,
                            startHour,
                            startMinute,
                            endHour,
                            endMinute,
                            lunchStartHour,
                            lunchStartMinute,
                            lunchEndHour,
                            lunchEndMinute,
                            startHourInputRef,
                            startMinuteInputRef,
                            endHourInputRef,
                            endMinuteInputRef,
                            lunchStartHourInputRef,
                            lunchStartMinuteInputRef,
                            lunchEndHourInputRef,
                            lunchEndMinuteInputRef,
                            isShowAlreadyAttestedModal,
                            timeCardDataFromTCPage,
                            disableSaveButton,
                        }
                    }}
                    onTabSelect={this.onTabSelect.bind(this)}
                    onSaveStartTimeLunchTime={this.onSaveStartTimeLunchTime.bind(this)}
                    onBackStartTimeLunchTime={this.onBackStartTimeLunchTime.bind(this)}
                    onChangePunches={this.onChangePunches.bind(this)}
                    onClickCreateTeam={this.onClickCreateTeam.bind(this)}
                    onClickBack={this.onClickBack.bind(this)}
                    onClickSave={this.onClickSave.bind(this)}
                    onEmployeeSearch={this.onEmployeeSearch.bind(this)}
                    onTaskSearch={this.onTaskSearch.bind(this)}
                    onEmployeeSelect={this.onEmployeeSelect.bind(this)}
                    onProjectSelect={this.onProjectSelect.bind(this)}
                    onTaskCodeSelect={this.onTaskCodeSelect.bind(this)}
                    onShiftSelect={this.onShiftSelect.bind(this)}
                    onChangeHours={this.onChangeHours.bind(this)}
                    onSaveHours={this.onSaveHours.bind(this)}
                    onSaveShift={this.onSaveShift.bind(this)}
                    onClickShiftModel={this.onClickShiftModel.bind(this)}
                    onCloseShiftModel={this.onCloseShiftModel.bind(this)}
                    onClickHoursModel={this.onClickHoursModel.bind(this)}
                    onCloseHoursModel={this.onCloseHoursModel.bind(this)}
                    onClickCreateTaskCodeGroupTeam={this.onClickCreateTaskCodeGroupTeam.bind(this)}
                    handleClickForEmpGrp={this.handleClickForEmpGrp.bind(this)}
                    onClickSelectAllCheckboxForEmpGroup={this.onClickSelectAllCheckboxForEmpGroup.bind(this)}
                    handleClickForTaskGrp={this.handleClickForTaskGrp.bind(this)}
                    onConfirmationCancel={this.onConfirmationCancel.bind(this)}
                    onConfirmationYes={this.onConfirmationYes.bind(this)}
                    goToEmpGroup={this.goToEmpGroup.bind(this)}
                    goToTaskCodeGroup={this.goToTaskCodeGroup.bind(this)}
                    onClickHoursTypeModel={this.onClickHoursTypeModel.bind(this)}
                    onSaveHoursType={this.onSaveHoursType.bind(this)}
                    onHoursTypeSelect={this.onHoursTypeSelect.bind(this)}
                    onCloseHoursTypeModel={this.onCloseHoursTypeModel.bind(this)}
                    onProjectSearch={this.onProjectSearch.bind(this)}
                    onClickNA={this.onClickNA.bind(this)}
                    onCloseAlreadyAttestModal={this.onCloseAlreadyAttestModal.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device,
        tab: state.tabReducer.tab,
        timeCard: state.timeCardDatasReducer.timeCardData,
        date: state.dateReducer.date,
        previousHistoryReducer: state.historyReducer.history,
        projectAndTaskDatas: state.projectAndTaskReducer.projectAndTaskData,
        punches: state.lastSavedPunches.punches
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions,
            timeCardActions, onDefaultGroupByAction, onHistorySaveAction, projectAndTaskAction, lastSavedPunchesAction),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Employee));

Employee.displayName = 'Employee';